'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Calendar = function (_React$PureComponent) {
  _inherits(Calendar, _React$PureComponent);

  function Calendar() {
    _classCallCheck(this, Calendar);

    return _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).apply(this, arguments));
  }

  _createClass(Calendar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color;

      return _react2.default.createElement(
        'svg',
        { width: size, height: size, viewBox: '0 0 20 20' },
        _react2.default.createElement(
          'g',
          { fill: color, fillRule: 'evenodd' },
          _react2.default.createElement('path', { d: 'M3 17h14V8H3v9zM6.923 6.3V3.729a.265.265 0 0 0-.091-.201.307.307 0 0 0-.217-.085H6a.307.307 0 0 0-.216.085.265.265 0 0 0-.092.2V6.3c0 .077.03.144.092.2.06.057.133.086.216.086h.615a.307.307 0 0 0 .217-.085.265.265 0 0 0 .091-.201zm7.385 0V3.729a.265.265 0 0 0-.092-.201.307.307 0 0 0-.216-.085h-.615a.307.307 0 0 0-.217.085.265.265 0 0 0-.091.2V6.3c0 .077.03.144.091.2.061.057.133.086.217.086H14a.307.307 0 0 0 .216-.085.265.265 0 0 0 .092-.201zM18 5.729v11.13c0 .31-.122.578-.365.804a1.23 1.23 0 0 1-.866.34H3.231a1.23 1.23 0 0 1-.866-.34A1.061 1.061 0 0 1 2 16.859V5.73c0-.31.122-.578.365-.804a1.23 1.23 0 0 1 .866-.34h1.23V3.73c0-.393.151-.73.452-1.01A1.54 1.54 0 0 1 6 2.3h.615c.423 0 .786.14 1.087.42.301.28.452.616.452 1.009v.857h3.692v-.857c0-.393.15-.73.452-1.01a1.54 1.54 0 0 1 1.087-.419H14c.423 0 .785.14 1.087.42.3.28.451.616.451 1.009v.857h1.231c.334 0 .622.113.866.339.243.226.365.494.365.804z' }),
          _react2.default.createElement('path', { d: 'M9.5 7h1v10h-1V7zm4 0h1v10h-1V7zm-8 .3h1v10h-1v-10z' }),
          _react2.default.createElement('path', { d: 'M17 12v1H3v-1z' })
        )
      );
    }
  }]);

  return Calendar;
}(_react2.default.PureComponent);

Calendar.defaultProps = {
  size: 20,
  color: '#666666'
};

Calendar.propTypes = {
  size: _propTypes2.default.number,
  color: _propTypes2.default.string
};

exports.default = Calendar;